/**
 *
 * @param content
 * @param currentTimePeriod
 * @returns {boolean}
 */
export function canDisplayContent(content, currentTimePeriod) {
    return content.active === true && content.displayTimePeriods.indexOf(currentTimePeriod) > -1;
}